import { Customized } from "recharts";

export type ChartEmptyStateProps = {
  message: string;
  secondaryMessage?: string;
};

const TEXT_STYLE = {
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "14px",
  fontWeight: 500,
  fill: "#DF7A23",
} as const;

export function renderChartEmptyState({
  message,
  secondaryMessage,
}: ChartEmptyStateProps) {
  return (
    <Customized
      key="empty-state"
      component={(props: any) => {
        const { width, height, offset } = props;
        if (!offset || !width || !height) return null;

        const cx = offset.left + (width - offset.left - offset.right) / 2;
        const cy = offset.top + (height - offset.top - offset.bottom) / 2;

        if (!secondaryMessage) {
          return (
            <text
              x={cx}
              y={cy}
              textAnchor="middle"
              dominantBaseline="middle"
              style={TEXT_STYLE}
            >
              {message}
            </text>
          );
        }

        return (
          <g>
            <text
              x={cx}
              y={cy - 10}
              textAnchor="middle"
              dominantBaseline="middle"
              style={TEXT_STYLE}
            >
              {message}
            </text>
            <text
              x={cx}
              y={cy + 10}
              textAnchor="middle"
              dominantBaseline="middle"
              style={TEXT_STYLE}
            >
              {secondaryMessage}
            </text>
          </g>
        );
      }}
    />
  );
}
